import { render, staticRenderFns } from "./zz.vue?vue&type=template&id=5e3d2118&scoped=true&"
import script from "./zz.vue?vue&type=script&lang=js&"
export * from "./zz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d2118",
  null
  
)

export default component.exports